export const GET_AI_VALUE_BOARD = `
  query GetAiValueBoard($element3Map: String, $element4Map: String) {
    getAiValueBoard(element3Map: $element3Map, element4Map: $element4Map) {
      workloadId
      workloadName
      modelId
      ytdActualCost
      estimateDollar
      projectedAnnualEstimate
      investmentProspectRatio
      investmentProspectBand
    }
  }
`

export const GET_AI_VALUE_OPPORTUNITY = `
  query GetAiValueOpportunity($element3Map: String, $element4Map: String) {
    getAiValueOpportunity(element3Map: $element3Map, element4Map: $element4Map) {
      costSavingOpportunity
      revenueDrivingOpportunity
    }
  }
`

// TS shapes of the live responses, used by useAIValueBoard + the
// ValueBoard children. Kept colocated with the queries they describe so
// the wire contract stays in one place.
export type AiValueBoardEntry = {
  workloadId: string
  workloadName: string | null
  modelId: string | null
  ytdActualCost: number | null
  estimateDollar: number | null
  projectedAnnualEstimate: number | null
  investmentProspectRatio: number | null
  // Matches the ProspectBand union in components/ValueBoard/investmentProspect.ts.
  investmentProspectBand: 'STRONG' | 'SOLID' | 'MODEST' | 'MARGINAL' | 'UNDERWATER' | 'UNBACKED'
}

export type AiValueOpportunity = {
  costSavingOpportunity: number | null
  revenueDrivingOpportunity: number | null
}
